import { Row, Col, Carousel, Button, Tooltip } from '@arkas/coreui';
import { MenuItemDto } from '@emutabakat-types/app';
import { NavLink } from 'react-router-dom';
import React from 'react';

interface CustomMenuCarouselProps {
  carouselItems: MenuItemDto[];
  togglePopOver: Function;
}

interface CustomMenuCarouselStates {
  sectionsPerTab: number;
}

/**
 * CustomMenuCarousel Component
 */
class CustomMenuCarousel extends React.Component<
  CustomMenuCarouselProps,
  CustomMenuCarouselStates
> {
  constructor(props: CustomMenuCarouselProps) {
    super(props);
    this.state = {
      sectionsPerTab: 6
    };
  }

  seperateTabs(items: MenuItemDto[]) {
    const { sectionsPerTab } = this.state;

    const tabs = [];
    let singleTab = [];

    let i = 0;
    while (i < items.length) {
      if (i % sectionsPerTab === 0 && i !== 0) {
        tabs.push(singleTab);
        singleTab = [];
        singleTab.push(items[i]);
      } else {
        singleTab.push(items[i]);
      }
      i++;
    }

    // Eğer bir dahaki 6'nın katı olan sayıya gelmeden döngüden çıkılırsa
    // kalan elemanlar da, son tab olarak ekleniyor.
    if (singleTab.length !== 0) {
      tabs.push(singleTab);
    }

    return tabs;
  }

  render() {
    const { carouselItems, togglePopOver } = this.props;
    const { sectionsPerTab } = this.state;
    const tabs = this.seperateTabs(carouselItems);
    return (
      <Carousel draggable={true}>
        {tabs.map((tabCol, k) => (
          <Row key={k.toString()}>
            {tabCol.map((tab, i) => (
              <Col span={24 / sectionsPerTab} key={i.toString()}>
                <h3>{tab.title}</h3>
                <ul style={{ listStyle: 'none', paddingLeft: 0, margin: 0 }}>
                  {tab.items &&
                    tab.items.map((tabItem, j) => (
                      <li key={j.toString()}>
                        <Tooltip title={tabItem.title} mouseEnterDelay={1.2}>
                          <NavLink to={tabItem.url as string}>
                            <Button
                              icon={tabItem.icon}
                              className={!tabItem.icon ? 'no-icon' : ''}
                              onClick={togglePopOver(false)}
                              ghost={true}
                              style={{ width: '100%', border: 'none' }}
                            >
                              {tabItem.title}
                            </Button>
                          </NavLink>
                        </Tooltip>
                      </li>
                    ))}
                </ul>
              </Col>
            ))}
          </Row>
        ))}
      </Carousel>
    );
  }
}

export default CustomMenuCarousel;
